import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Play, X } from 'lucide-react';

export const FILM_SRC = '/videos/company-film.mp4';
export const FILM_POSTER = '/social/impact-as-plus-film-poster.webp';

export const filmJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'VideoObject',
  name: 'Impact AS Plus™',
  description: 'Impact AS Plus™ connects assessments, development and progress in one record across the leader, the team and the organisation, so the decisions you make about people rest on evidence you can explain and defend.',
  thumbnailUrl: 'https://resiligent.com/social/impact-as-plus-film-poster.jpg',
  contentUrl: 'https://resiligent.com/videos/company-film.mp4',
  embedUrl: 'https://resiligent.com/client/resiligent/company-film',
  uploadDate: '2026-11-03',
  duration: 'PT5M6S',
};

export const ImpactFilmInline = () => {
  const videoRef = useRef(null);
  const [started, setStarted] = useState(false);

  const start = () => {
    setStarted(true);
    videoRef.current?.play();
  };

  return (
    <div className="relative w-full aspect-video rounded-xl overflow-hidden bg-black border border-slate-200 shadow-sm mb-8" data-testid="impact-film">
      <video
        ref={videoRef}
        className="w-full h-full object-cover"
        controls={started}
        playsInline
        preload="none"
        poster={FILM_POSTER}
        src={FILM_SRC}
        data-testid="impact-film-video"
      />
      {!started && (
        <button
          type="button"
          onClick={start}
          className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-black/30 hover:bg-black/20 transition-colors duration-300 group"
          aria-label="Play the Impact AS Plus film"
          data-testid="impact-film-play-btn"
        >
          <span className="w-16 h-16 lg:w-20 lg:h-20 rounded-full bg-[#2693d0] flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-300">
            <Play size={30} className="text-white ml-1" fill="currentColor" />
          </span>
          <span className="inline-flex items-center gap-2 bg-[#2693d0] text-white px-5 py-2.5 rounded font-medium text-sm lg:text-base" data-testid="impact-film-watch-btn">
            Watch the film
          </span>
        </button>
      )}
    </div>
  );
};

export const ImpactFilmModal = ({ onClose }) => createPortal(
  <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4" onClick={onClose} data-testid="impact-film-modal">
    <div className="relative w-full max-w-5xl" onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        onClick={onClose}
        className="absolute -top-11 right-0 text-white/80 hover:text-white p-2"
        aria-label="Close film"
        data-testid="impact-film-modal-close"
      >
        <X size={26} />
      </button>
      <video
        className="w-full aspect-video bg-black rounded-lg"
        controls
        autoPlay
        playsInline
        poster={FILM_POSTER}
        src={FILM_SRC}
        data-testid="impact-film-modal-video"
      />
    </div>
  </div>,
  document.body
);
